import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from 'react-router-dom';
import { NavigationPath } from '~/core/dto/navigationDTO';
import Email from '~/screens/Email';
import FinancialIQ from '~/screens/FinancialIQ';
import GrowthPlan from '~/screens/GrowthPlan';
import Home from '~/screens/Home';
import Intro from '~/screens/Intro';
import PersonalGrowth from '~/screens/PersonalGrowth';
import QuizIntro from '~/screens/QuizIntro';
import QuizQuestion from '~/screens/QuizQuestion';
import QuizResult from '~/screens/QuizResult';

const RootNavigator = () => (
  <Router>
    <Routes>
      <Route path={NavigationPath.Home} element={<Home type="parent" />} />
      <Route path={NavigationPath.Intro} element={<Intro type="parent" />} />
      <Route path={NavigationPath.QuizIntro} element={<QuizIntro type="parent" />} />
      <Route path={NavigationPath.QuizQuestion} element={<QuizQuestion type="parent" />} />
      <Route path={NavigationPath.PersonalGrowth} element={<PersonalGrowth type="parent" />} />
      <Route path={NavigationPath.FinancialIQ} element={<FinancialIQ type="parent" />} />
      <Route path={NavigationPath.Email} element={<Email type="parent" />} />
      <Route path={NavigationPath.GrowthPlan} element={<GrowthPlan type="parent" />} />
      <Route path={NavigationPath.QuizResult} element={<QuizResult type="parent" />} />

      <Route path={NavigationPath.AdultHome} element={<Home type="adult" />} />
      <Route path={NavigationPath.AdultIntro} element={<Intro type="adult" />} />
      <Route path={NavigationPath.AdultQuizIntro} element={<QuizIntro type="adult" />} />
      <Route path={NavigationPath.AdultQuizQuestion} element={<QuizQuestion type="adult" />} />
      <Route path={NavigationPath.AdultFinancialIQ} element={<FinancialIQ type="adult" />} />
      <Route path={NavigationPath.AdultEmail} element={<Email type="adult" />} />
      <Route path={NavigationPath.AdultQuizResult} element={<QuizResult type="adult" />} />
    </Routes>
  </Router>
);

export default RootNavigator;
